import { render, staticRenderFns } from "./NvListItem.vue?vue&type=template&id=5d82890f&"
import script from "./NvListItem.ts?vue&type=script&lang=ts&"
export * from "./NvListItem.ts?vue&type=script&lang=ts&"
import style0 from "./NvListItem.vue?vue&type=style&index=0&id=5d82890f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports